export const DEFAULT_LIMIT_COUNT = 100;

export const DEFAULT_COLUMN_HEADER_HEIGHT = 40;

export const ONLINE_STATUS_THRESHOLD_MS = 900000; // 15 min

export const LON_LAT_NAME_PATTERN = /^-?[0-9]+(\.[0-9]+)?$/;

export const SIMPLE_NAME_PATTERN = /^[A-Za-z0-9 -]+$/;

export const ZONE_NAME_PATTERN = /^[a-zA-Z0-9\-_. @#$%&*!]+(?<![\\/:*?"<>|])$/;

export const PAN_TILT_PATTERN = /^(?!-\.|\.-|\.)(?:-?\d*(?:\.\d{0,2})?|)$/;

export const IP_MASK_PATTERN =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const Z_INDEX_PRIORITY = {
  HEADER: 5,
  LEFT_BAR: 3,
  LEFT_BAR_COLLAPSE_ICON: 4,
  FULL_PAGE_LOADER: 5,
};

export const DEFAULT_DEVICE_PASSWORD = "admin:ccai1CCAI";
